<script>
import Papa from 'papaparse'
import { ref } from 'vue'
import JsBarcode from 'jsbarcode';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import OnHandComp from '@/components/OnHandComp.vue';
import { Timestamp } from 'firebase/firestore';

import { getDB, resetDay } from '@/firebase'
import { collection, onSnapshot } from 'firebase/firestore';
import { arrayUnion } from 'firebase/firestore'
import { getFirestore, doc, updateDoc, getDocs, getDoc } from "firebase/firestore";

const ohuData = doc(getDB(), "ohu-list", "jIAzyK9CTJzAVClkkexX");


export default {
  props: {
    value: String,
  },
  components: {
    OnHandComp
  },
  data() {
    return {
      barcodeValue: '',
      barcodeList: [],
      currentPos: 0,
      generated: false,
      updateAll: false,
      actualArr: [],
      loading:true,
      items:[],
      hideBarcode:false
    }
  },
  methods: {
    updateEverything(){//show barcode
      this.updateAll = !this.updateAll
      this.generated = true
      console.log("updated : " + this.updateAll)
    },
    async addBarcode(e){
      if(this.barcodeValue == ''){
          alert("Please enter your style number.");
          return;
      }
      if((this.barcodeValue.length < 13) || (this.barcodeValue.length > 14)){
        // alert("Incorrect barcode length");
          return;
      }
      //adds barcode to list
        if(this.barcodeValue){
            this.barcodeList.push(this.barcodeValue)
            // console.log(this.barcodeList)
        }
        var d = new Date();
        const midnightDate = new Date(d).setHours(0, 0, 0, 0);
        if(this.actualArr?.length === 0 || this.actualArr === undefined){
            (this.actualArr ??= []).push(midnightDate);
            (this.actualArr ??= []).push(this.barcodeValue);
        }else{
            (this.actualArr ??= []).push(this.barcodeValue);
            console.log('heyy')
            console.log(this.actualArr)
        }


          await updateDoc(ohuData, {
            barcodes: this.actualArr,
            //updatedAt: Date.now()
            });


          // const querySnapshot = await getDocs(collection(getDB(), 'ohu-list'));

            // const res = await ohuData.update({
            //     barcodes: this.actualArr
            // });

          // querySnapshot.doc('jIAzyK9CTJzAVClkkexX').update({
          //      barcodes: arrayUnion(barcodeObj)
          // })
          this.barcodeValue = ''


  },
  handleInput(){
    if((this.barcodeValue.length < 13) || (this.barcodeValue.length > 14)){
        document.getElementById("input-text").style.color = "red";
    }else{
        document.getElementById("input-text").style.color = "black";
    }
  }
    //test barcode
    //30058633
    //97609353
    //04061833
  },
  async mounted() {
    try {
      if(this.actualArr.length === 0 || this.actualArr === undefined){
        // const querySnapshot = await getDocs(collection(getDB(), "ohu-list"));

        const docRef = doc(getDB(), "ohu-list", "jIAzyK9CTJzAVClkkexX");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const sourceArray = docSnap.data().barcodes || [];

          // 2. Copy it to a new local array using the spread operator
          const newArray = [...sourceArray];
          this.actualArr = newArray
        }
      }

      // if(this.actualArr.length === 0 || this.actualArr === undefined){
      //   this.actualArr = this.items[0].barcodes
      //   console.log('this is hapening')
      //   console.log(this.items[0].barcodes)
      //   // this.barcodeList = this.items[0].barcodes
      // }

    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      this.loading = false;
    }
    // resetDay()//just to test, this must run every day one time at midnight

  }
}
</script>

<template>
    <h1>On Hand Updates</h1>
    <p>Enter style number, press enter, generate list of barcodes when ready.</p>
    <div class="top">
        <input id="input-text" @input="handleInput" v-model="barcodeValue" @keyup.enter="addBarcode" placeholder="Enter style number" />
        <button @click="updateEverything">Create Barcodes</button>
    </div>


    <div class="barcodeDisplay" v-if="!generated">
        <div v-for="(barcodes, barcodeIndex) in actualArr">
            {{ actualArr[barcodeIndex] }}
        </div>

    </div>
    <div v-else>
        Barcodes Generated
    </div>


    <div v-for="(barcodes, barcodeIndex) in actualArr" :key="barcodeIndex" class="barcodes">
        <div class="page-content">
            <div v-if="barcodeIndex > 0">
                <OnHandComp v-if="!hideBarcode" @close="isVisible = false" :barcodeValue="this.actualArr[barcodeIndex]" :index="barcodeIndex" :updateAll="this.updateAll"/>
            </div>

        </div>

    </div>


</template>

<style lang="scss" scoped>
.page-content{
    margin: auto;
    height:200px;
    width: 200px;
    max-width: 200px;
    max-height: 200px;
    // padding:1em;
}
.top{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1em;
    margin-left: 40%;
    margin-right: 40%;

    button{
        border-radius: 10px;
        // border-style: none;
        padding:1em;
    }

}
.barcodeDisplay{
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* Creates 5 equal columns */
    gap: 5px;
}
</style>